export default "### Finance loan amount calculator\n\nEnter some details to find out your total loan amount.\n";